import { render, staticRenderFns } from "./WhoIsWho.vue?vue&type=template&id=d2ae90e0&lang=pug&"
import script from "./WhoIsWho.vue?vue&type=script&lang=js&"
export * from "./WhoIsWho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports